export default __webpack_public_path__ + "static/media/VolvoVirtualShowroomSplashScreenMaster.a52141aa.jpg";